<!--
  -  Copyright (c) Qwoach LLC 2023. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 10/10/2023
  -->

<template>
	<div>
		<div
			class="card p-2 qw-row"

		>
<!--			:class="{ 'is-active': menu.isActive && linkMenuIsActive}"-->
<!--			:style="`left: ${menu.left}px; bottom: ${menu.bottom}px;opacity:${linkMenuIsActive ? '0' : '0'}}`"-->

<!--			<form class="menububble__form"-->
<!--				  @submit.prevent="setLinkUrl()">-->
<!--				<input class="menububble__input" type="text" v-model="linkUrl" placeholder="https://"-->
<!--					   ref="linkInput" @keydown.esc="closeMenu"/>-->
<!--				<a class="menububble__button" :href="linkUrl" target="_blank">-->
<!--					<i class="fontello icon-link-ext"/>-->
<!--				</a>-->
<!--				<button class="menububble__button" @click="setLinkUrl()" type="button">-->
<!--					<i class="fontello icon-ok-circled2"/>-->
<!--				</button>-->
<!--				<button class="menububble__button" @click="unsetLinkUrl()" type="button">-->
<!--					<i class="fontello icon-cancel-circled2"/>-->
<!--				</button>-->
<!--			</form>-->

			<div>
				Go to link:&nbsp;<qw-link :link="linkUrl" @click="hideMenu"/>
				<el-divider direction="vertical" />
				<qw-link-button @click="$emit('change')">Change</qw-link-button>
				<el-divider direction="vertical" />
				<qw-link-button @click="onRemoveClicked">Remove</qw-link-button>
			</div>


		</div>
	</div>
</template>

<script>
import BaseComponent from "@/core/components/BaseComponent.vue";
import {Editor} from '@tiptap/vue-3'

export default {
	name: "LinkEditBubbleMenu",
	extends: BaseComponent,

	props: {
		editor: {Editor, required: true},
	},

	data() {
		return {
			linkUrl: null,
		}
	},

	mounted(){
		this.refreshLink()
	},

	methods: {

		refreshLink(){
			this.linkUrl = this.editor.getAttributes('link').href

		},

		onRemoveClicked(){
			this.unsetLinkUrl()
		},



		unsetLinkUrl(){
			console.log("LinkEditBubbleMenu.unsetLinkUrl")
			this.editor
				.chain()
				.focus()
				.unsetLink()
				.run()
			this.hideMenu()
		},

		hideMenu(){
			this.$emit("hideMenu")
		},
	},
}
</script>

<style lang="scss">
$color-white:    #fff !default;
$color-grey: #aaaaaa !default;
$color-black:    #000 !default;

.menububble {
	//position: absolute;
	//display: flex;
	//z-index: 20;
	background: $color-white;
	border-radius: 5px;
	padding: 0.3rem;
	margin-bottom: 0.5rem;
	//transform: translateX(-50%);
	//visibility: hidden;
	//opacity: 0;
	transition: opacity 0.2s, visibility 0.2s;

	&.is-active {
		opacity: 1;
		visibility: visible;
	}

	&__button {
		display: inline-flex;
		background: transparent;
		border: 0;
		color: $color-white;
		padding: 0.2rem 0.5rem;
		margin-right: 0.2rem;
		border-radius: 3px;
		cursor: pointer;

		&:last-child {
			margin-right: 0;
		}

		&:hover {
			background-color: rgba($color-white, 0.1);
		}

		&.is-active {
			background-color: rgba($color-white, 0.2);
		}
	}

	&__form {
		display: flex;
		align-items: center;
	}

	&__input {
		font: inherit;
		border: none;
		background: transparent;
		color: $color-white;
	}
}
</style>
